import { createSelector } from '@reduxjs/toolkit';

const isochronousState = (state) => state.isochronous;

// Retrieve the Map state specific objects
export const selectOldIsochronous = createSelector(isochronousState, (isochronous) => isochronous.oldIsochronous);
export const selectEditing = createSelector(isochronousState, (isochronous) => isochronous.editing);
export const selectShowAll = createSelector(isochronousState, (isochronous) => isochronous.map.showAll);
export const selectUpdatedLocation = createSelector(
	isochronousState,
	(isochronous) => isochronous.map.updatedLocationData
);
export const selectInfoWindow = createSelector(isochronousState, (isochronous) => isochronous.map.infoWindow);
